import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar
  },
  data: function() {
    return {
      region_id: 0,
      subject_id: 0,
      schedule_id: 0,
      examSite_id: 0,
      dialogVisible: false,
      Data: {},
      loading: {},
      key: "",
      time: "",
      num: 0
    };
  },
  methods: {
    getData() {
      this.$http.post(globalProvider.serviceUrl("er/g/said")).then(data => {
        if (data.body.code == resultCode.Success) {
          if (
            data.body.data == null ||
            Object.keys(data.body.data).length == 0
          ) {
            this.Data = [];
          } else {
            for (let key in data.body.data) {
              this.region_id = key;
            }
            this.subject_id = 0;
            this.schedule_id = 0;
            this.examSite_id = 0;
            this.Data = data.body.data;
          }
        } else if (data.body.code == resultCode.NotSuccess) {
          let message;
          if (data.body.data.notification) {
            message = data.body.data.notification;
          } else {
            message = data.body.message;
          }
          this.$alert(getErrorMessage(message), "提示", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true
          });
        }
      });
    },
    onSubject: function(index) {
      this.subject_id = index;
      this.schedule_id = 0;
      this.examSite_id = 0;
    },
    onSchedule: function(index) {
      this.schedule_id = index;
      this.examSite_id = 0;
    },
    order(index) {
      this.examSite_id = index;
      this.dialogVisible = true;
    },
    postOrder() {
      this.$http
        .post(globalProvider.serviceUrl("er/s/g"), {
          sch_id: this.schedule_id,
          sub_id: this.subject_id,
          o_id: this.examSite_id
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            this.key = data.body.data;
            this.loading = this.$loading({
              lock: true,
              spinner: "order-loading",
              background: "#fff"
            });
            this.num = 0;
            this.getOrderState();
            this.dialogVisible = false;
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message), "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    },
    getOrderState: function() {
      this.$http
        .get(globalProvider.serviceUrl("e_reg/g/ps/{key}"), {
          params: {
            key: this.key
          }
        })
        .then(data => {
          this.num++;
          if (data.body.data.status == "succeed") {
            this.loading.close();
            this.$alert("预约成功", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.getData();
              }
            });
          } else if (
            data.body.data.status == "failed" ||
            data.body.data.status == "exception"
          ) {
            this.loading.close();
            this.$alert(data.body.data.result, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.num++;
            if (this.num < 16) {
              clearTimeout(this.time);
              this.time = setTimeout(this.getOrderState, 2000);
            } else {
              this.loading.close();
              this.$alert("请求人数过多,请稍后再试", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        });
    },
    enter: function(e) {
      var dom = e.target;
      dom.lastChild.style.display = "block";
      //                if (dom.childNodes[6].className == 'yes-order') {
      //                    dom.childNodes[6].style.display = "none";
      //                }
    },
    leave: function(e) {
      var dom = e.target;
      dom.lastChild.style.display = "none";
      //                dom.childNodes[6].style.display = "block";
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "2");
    this.getData();
  }
};